import type { Theme } from '~styles/theme';

export const buildCookieConsentTheme = (theme: Theme): string => `
    #cc-main {
        --cc-font-family: ${theme.font.family};
        --cc-bg: ${theme.colors.background.primary};
        --cc-primary-color: ${theme.colors.foreground.primary};
        --cc-secondary-color: ${theme.colors.foreground.secondary};
        --cc-text-color: ${theme.colors.foreground.primary};
        --cc-btn-primary-bg: ${theme.colors.accent.primary};
        --cc-btn-primary-color: ${theme.colors.foreground.onPrimary};
        --cc-btn-primary-hover-bg: ${theme.colors.buttons.primary.hover};
        --cc-btn-primary-hover-color: ${theme.colors.foreground.onPrimary};
        --cc-btn-secondary-bg: ${theme.colors.background.secondary};
        --cc-btn-secondary-color: ${theme.colors.foreground.primary};
        --cc-btn-secondary-hover-bg: ${theme.colors.border.cards};
        --cc-btn-secondary-hover-color: ${theme.colors.foreground.primary};
        --cc-separator-border-color: ${theme.colors.border.cards};
        --cc-toggle-on-bg: ${theme.colors.accent.primary};
        --cc-toggle-off-bg: ${theme.colors.border.cards};
        --cc-toggle-on-knob-bg: ${theme.colors.foreground.onPrimary};
        --cc-toggle-off-knob-bg: ${theme.colors.foreground.onPrimary};
        --cc-modal-border-radius: 12px;
        --cc-btn-border-radius: 8px;
        --cc-overlay-bg: rgba(42, 41, 47, 0.4);
    }

    #cc-main .cc__link {
        color: ${theme.colors.accent.primary};
        text-decoration: underline;
    }

    #cc-main .cc__link:hover {
        color: ${theme.colors.accent.secondary};
        text-decoration: none;
    }
`;
